import type { MouseEvent } from 'react'
import { Copy } from 'lucide-react'
import { toast } from '@/hooks/use-toast'
import { cn } from '@/lib/utils'

export function CopyTickerButton({ symbol, className }: { symbol: string; className?: string }) {
  const copyTicker = async (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    try {
      await navigator.clipboard.writeText(symbol)
      toast({ title: `Copied ${symbol}` })
    } catch {
      toast({ title: `Failed to copy ${symbol}`, variant: 'destructive' })
    }
  }

  return (
    <button
      type="button"
      title={`Copy ${symbol} ticker`}
      aria-label={`Copy ${symbol} ticker`}
      onClick={(event) => void copyTicker(event)}
      className={cn('inline-flex h-8 w-8 shrink-0 items-center justify-center rounded text-muted-foreground transition-colors hover:bg-muted/30 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-400', className)}
    >
      <Copy className="h-3.5 w-3.5" aria-hidden="true" />
    </button>
  )
}
